module.exports = __webpack_public_path__ + "img/cyber.b8311abb.jpg";